"use client";

type Screen4FinalProps = {
  onComplete: () => void;
};

export function Screen4Final({ onComplete }: Screen4FinalProps) {
  return (
    <div className="flex flex-1 flex-col justify-between">
      <div className="flex flex-1 flex-col justify-center">
        <h1
          className="mb-6 text-[2.5rem] leading-[1.1] text-foreground animate-fade-in-up"
          style={{ animationDelay: "0.15s", opacity: 0 }}
        >
          Someone out there is about to be seen.
        </h1>
        <p
          className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground animate-fade-in-up"
          style={{ animationDelay: "0.3s", opacity: 0 }}
        >
          First drop. Make it count.
        </p>
      </div>
      <div
        className="w-full pt-8 animate-fade-in-up"
        style={{ animationDelay: "0.45s", opacity: 0 }}
      >
        <button
          type="button"
          onClick={onComplete}
          className="w-full rounded-lg bg-accent py-7 font-mono text-base uppercase tracking-[0.15em] text-accent-foreground transition-all duration-200 hover:brightness-110"
        >
          Drop it
        </button>
      </div>
    </div>
  );
}
